module.exports = __webpack_public_path__ + "static/media/virtaskHeaderLogo.5c646534.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/components/Header/virtaskHeaderLogo.png
// module id = 480
// module chunks = 0